// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { API, BASE_URL } from "../api";
// import { Pie } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
// import Layout from "../components/Layout";
// import "../components/layout.css";

// ChartJS.register(ArcElement, Tooltip, Legend, Title);

// export default function Dashboard() {
//   const navigate = useNavigate();

//   const [user, setUser] = useState(null);
//   const [date, setDate] = useState(new Date().toISOString().split("T")[0]);

//   const [stats, setStats] = useState({
//     availableVehicles: 0,
//     newBooking: 0,
//     onRent: 0,
//     pickup: 0,
//     returnToday: 0,
//     requestedCar: 0,
//     inquiry: 0,
//   });

//   const [availRows, setAvailRows] = useState([]);
//   const [calData, setCalData] = useState([]);
//   const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));

//   const [activeBox, setActiveBox] = useState("available");

//   const [tableRows, setTableRows] = useState([]);
//   const [tableTitle, setTableTitle] = useState("Available Vehicles");

//   const [modal, setModal] = useState(null);
//   const [modalTitle, setModalTitle] = useState("");

//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const token = localStorage.getItem("token");

//     if (!token) {
//       navigate("/login");
//       return;
//     }

//     try {
//       setUser(JSON.parse(localStorage.getItem("user")));
//     } catch (error) {
//       console.error("Unable to load user:", error);
//     }
//   }, [navigate]);

//   useEffect(() => {
//     fetchStats();
//   }, [date]);

//   useEffect(() => {
//     fetchCal();
//   }, [month]);

//   const fetchStats = async () => {
//     setLoading(true);

//     try {
//       const r = await API.get(`/dashboard/stats?date=${date}`);

//       setStats(r.data.stats);
//       setAvailRows(r.data.availableRows);

//       if (activeBox === "available") {
//         setTableRows(r.data.availableRows);
//       }
//     } catch (e) {
//       console.error(e);
//     }

//     setLoading(false);
//   };

//   const fetchCal = async () => {
//     try {
//       const r = await API.get(`/dashboard/calendar?month=${month}`);

//       setCalData(r.data);
//     } catch (e) {
//       console.error(e);
//     }
//   };

//   const fetchFilter = async (type, label) => {
//     setActiveBox(type);
//     setTableTitle(label);

//     if (type === "available") {
//       setTableRows(availRows);
//       return;
//     }

//     try {
//       const r = await API.get(`/dashboard/filter?date=${date}&type=${type}`);

//       setTableRows(r.data);
//     } catch (e) {
//       console.error(e);
//     }
//   };

//   const fetchModal = async (type, id) => {
//     try {
//       const r = await API.post(`/dashboard/${type}`, { id });

//       setModal(r.data);

//       setModalTitle(
//         type === "booking"
//           ? "Booking Details"
//           : type === "inquiry"
//           ? "Inquiry Details"
//           : "Request Details"
//       );
//     } catch (e) {
//       console.error(e);
//     }
//   };

//   const prevMonth = new Date(`${month}-01`);

//   prevMonth.setMonth(prevMonth.getMonth() - 1);

//   const nextMonth = new Date(`${month}-01`);

//   nextMonth.setMonth(nextMonth.getMonth() + 1);

//   const curMonth = new Date().toISOString().slice(0, 7);

//   const getDates = () => {
//     const [y, m] = month.split("-").map(Number);

//     const today = new Date();

//     today.setHours(0, 0, 0, 0);

//     const days = new Date(y, m, 0).getDate();

//     const dates = [];

//     for (let d = 1; d <= days; d++) {
//       const dt = new Date(y, m - 1, d);

//       if (dt >= today) {
//         dates.push(dt.toISOString().split("T")[0]);
//       }
//     }

//     return dates;
//   };

//   const monthDates = getDates();

//   const pieData = {
//     labels: ["New Bookings", "On Rent", "Pickup", "Return", "Available"],
//     datasets: [
//       {
//         data: [
//           stats.newBooking,
//           stats.onRent,
//           stats.pickup,
//           stats.returnToday,
//           stats.availableVehicles,
//         ],
//         backgroundColor: [
//           "#6C63FF",
//           "#FF6584",
//           "#43BCCD",
//           "#F7B731",
//           "#26de81",
//         ],
//         borderWidth: 2,
//         borderColor: "#fff",
//       },
//     ],
//   };

//   const pieOpts = {
//     responsive: true,
//     maintainAspectRatio: true,
//     plugins: {
//       legend: {
//         position: "bottom",
//         labels: {
//           font: {
//             size: 11,
//             family: "DM Sans",
//           },
//           padding: 12,
//         },
//       },
//       title: {
//         display: false,
//       },
//     },
//   };

//   const STAT_CARDS = [
//     {
//       key: "available",
//       label: "Available",
//       value: stats.availableVehicles,
//       icon: "🟢",
//     },
//     {
//       key: "newBooking",
//       label: "New Bookings",
//       value: stats.newBooking,
//       icon: "📅",
//     },
//     {
//       key: "onRent",
//       label: "On Rent",
//       value: stats.onRent,
//       icon: "🚗",
//     },
//     {
//       key: "pickup",
//       label: "Pickup",
//       value: stats.pickup,
//       icon: "📍",
//     },
//     {
//       key: "returnToday",
//       label: "Returns",
//       value: stats.returnToday,
//       icon: "🔄",
//     },
//   ];

//   return (
//     <Layout activePage="Dashboard">
//       <div className="dashboard-page">
//         <main className="dashboard-main">
//           {/* Request / Inquiry */}

//           <div className="dashboard-pill-row">
//             {[
//               {
//                 key: "request",
//                 label: "Requested Cars",
//                 value: stats.requestedCar,
//               },
//               {
//                 key: "inquiry",
//                 label: "Inquiries",
//                 value: stats.inquiry,
//               },
//             ].map((p) => (
//               <button
//                 key={p.key}
//                 className={`dashboard-pill ${
//                   activeBox === p.key
//                     ? p.key === "request"
//                       ? "active-request"
//                       : "active-inquiry"
//                     : ""
//                 }`}
//                 onClick={() => fetchFilter(p.key, p.label)}
//               >
//                 {p.label}

//                 <span className="dashboard-pill-badge">{p.value}</span>
//               </button>
//             ))}
//             <div className="dashboard-top-right">
//               <div className="dashboard-date-wrap">
//                 <span className="dashboard-cal-icon">📅</span>

//                 <input
//                   type="date"
//                   value={date}
//                   onChange={(e) => setDate(e.target.value)}
//                   className="dashboard-date-pick"
//                 />
//               </div>

//               <div className="dashboard-notif-bell">🔔</div>
//             </div>
//           </div>

//           {/* Stat cards */}

//           <div className="dashboard-stat-grid">
//             {STAT_CARDS.map((c) => (
//               <div
//                 key={c.key}
//                 className={`dashboard-stat-card stat-${c.key} ${
//                   activeBox === c.key ? "active" : ""
//                 }`}
//                 onClick={() => fetchFilter(c.key, c.label)}
//               >
//                 <div className="dashboard-stat-top">
//                   <span className="dashboard-stat-icon">{c.icon}</span>

//                   <div className="dashboard-stat-badge">{c.value}</div>
//                 </div>

//                 <div className="dashboard-stat-label">{c.label}</div>
//               </div>
//             ))}
//           </div>

//           {/* Chart + Table */}

//           <div className="dashboard-mid-row">
//             {/* Pie */}

//             <div className="dashboard-pie-card">
//               <h3 className="dashboard-card-title">Fleet Summary</h3>

//               <Pie data={pieData} options={pieOpts} />
//             </div>

//             {/* Table */}

//             <div className="dashboard-table-card">
//               <div className="dashboard-table-header">
//                 <h3 className="dashboard-card-title">{tableTitle}</h3>

//                 <span className="dashboard-date-tag">{date}</span>
//               </div>

//               {loading ? (
//                 <div className="dashboard-loading-box">Loading…</div>
//               ) : (
//                 <div className="dashboard-scroll-x">
//                   <table className="dashboard-table">
//                     <thead>
//                       <tr>
//                         {activeBox === "available"
//                           ? [
//                               "Type",
//                               "Name",
//                               "Brand",
//                               "Stock",
//                               "On Rent",
//                               "Available",
//                               "",
//                             ].map((h) => <th key={h}>{h}</th>)
//                           : tableRows[0]
//                           ? [
//                               ...Object.keys(tableRows[0]).map((k) => (
//                                 <th key={k}>{k}</th>
//                               )),
//                               <th key="act"> </th>,
//                             ]
//                           : null}
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {activeBox === "available"
//                         ? availRows.map((r, i) => (
//                             <tr key={i}>
//                               <td>{r.group_name}</td>

//                               <td>{r.car_name}</td>

//                               <td>{r.car_brand}</td>

//                               <td>
//                                 <span className="dashboard-chip">
//                                   {r.total_stock}
//                                 </span>
//                               </td>

//                               <td>
//                                 <span className="dashboard-chip dashboard-chip-rent">
//                                   {r.on_rent}
//                                 </span>
//                               </td>

//                               <td>
//                                 <span className="dashboard-chip dashboard-chip-available">
//                                   {r.available_today}
//                                 </span>
//                               </td>

//                               <td>
//                                 <button className="dashboard-action-btn">
//                                   Book
//                                 </button>
//                               </td>
//                             </tr>
//                           ))
//                         : tableRows.map((r, i) => (
//                             <tr key={i}>
//                               {Object.values(r).map((v, j) => (
//                                 <td key={j}>{v}</td>
//                               ))}

//                               <td>
//                                 <button
//                                   className="dashboard-action-btn"
//                                   onClick={() =>
//                                     fetchModal(
//                                       activeBox === "inquiry"
//                                         ? "inquiry"
//                                         : activeBox === "request"
//                                         ? "request"
//                                         : "booking",
//                                       r.id ||
//                                         r.bookingid ||
//                                         r.cont_Id ||
//                                         r.req_id
//                                     )
//                                   }
//                                 >
//                                   View
//                                 </button>
//                               </td>
//                             </tr>
//                           ))}

//                       {tableRows.length === 0 && activeBox !== "available" && (
//                         <tr>
//                           <td colSpan={8} className="dashboard-empty-cell">
//                             No records found
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Calendar */}

//           <div className="dashboard-cal-card">
//             <div className="dashboard-cal-header">
//               <h3 className="dashboard-card-title">
//                 Car Availability —{" "}
//                 {new Date(`${month}-01`).toLocaleString("default", {
//                   month: "long",
//                   year: "numeric",
//                 })}
//               </h3>

//               <div className="dashboard-cal-nav">
//                 <button
//                   className="dashboard-nav-btn"
//                   disabled={month === curMonth}
//                   onClick={() => setMonth(prevMonth.toISOString().slice(0, 7))}
//                 >
//                   ← Prev
//                 </button>

//                 <button
//                   className="dashboard-nav-btn"
//                   onClick={() => setMonth(nextMonth.toISOString().slice(0, 7))}
//                 >
//                   Next →
//                 </button>
//               </div>
//             </div>

//             <div className="dashboard-scroll-x">
//               <table className="dashboard-table dashboard-calendar-table">
//                 <thead>
//                   <tr className="dashboard-calendar-head">
//                     <th className="dashboard-calendar-car-head">Car</th>

//                     {monthDates.map((d) => (
//                       <th key={d} className="dashboard-calendar-day-head">
//                         {new Date(d).getDate()}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {calData.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan={monthDates.length + 1}
//                         className="dashboard-empty-cell"
//                       >
//                         Loading…
//                       </td>
//                     </tr>
//                   ) : (
//                     (() => {
//                       let lastGroup = "";

//                       return calData.map((car, i) => {
//                         const rows = [];

//                         if (car.group_name !== lastGroup) {
//                           lastGroup = car.group_name;

//                           rows.push(
//                             <tr key={`g-${i}`}>
//                               <td
//                                 colSpan={monthDates.length + 1}
//                                 className="dashboard-group-row"
//                               >
//                                 {car.group_name}
//                               </td>
//                             </tr>
//                           );
//                         }

//                         rows.push(
//                           <tr key={`c-${i}`}>
//                             <td className="dashboard-car-cell">
//                               <img
//                                 src={`${BASE_URL}/${car.car_image}`}
//                                 alt={car.car_name}
//                                 className="dashboard-car-image"
//                               />

//                               <div>
//                                 <div className="dashboard-car-name">
//                                   {car.car_name}
//                                 </div>

//                                 <div className="dashboard-car-transmission">
//                                   {car.car_transmission}
//                                 </div>
//                               </div>
//                             </td>

//                             {monthDates.map((d) => {
//                               const booked = car.bookings?.[d] || 0;

//                               const avail = car.total_stock - booked;

//                               const availabilityClass =
//                                 avail <= 0
//                                   ? "none"
//                                   : avail < 2
//                                   ? "low"
//                                   : "available";

//                               return (
//                                 <td
//                                   key={d}
//                                   className={`dashboard-availability-cell ${availabilityClass}`}
//                                 >
//                                   {avail}
//                                 </td>
//                               );
//                             })}
//                           </tr>
//                         );

//                         return rows;
//                       });
//                     })()
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </main>

//         {/* Modal */}

//         {modal && (
//           <div className="dashboard-overlay" onClick={() => setModal(null)}>
//             <div
//               className="dashboard-modal-box"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div className="dashboard-modal-head">
//                 <h3 className="dashboard-card-title">{modalTitle}</h3>

//                 <button
//                   className="dashboard-close-btn"
//                   onClick={() => setModal(null)}
//                 >
//                   ✕
//                 </button>
//               </div>

//               <div className="dashboard-modal-body">
//                 <table className="dashboard-modal-table">
//                   <tbody>
//                     {Object.entries(modal).map(([k, v]) => (
//                       <tr key={k} className="dashboard-modal-row">
//                         <td className="dashboard-modal-key">{k}</td>

//                         <td className="dashboard-modal-value">{v}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="dashboard-modal-foot">
//                 <button
//                   className="dashboard-close-full"
//                   onClick={() => setModal(null)}
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </Layout>
//   );
// }
import React from "react";
import Layout from "../components/Layout";
import { BASE_URL } from "../api";
import "../components/layout.css";

export default function Dashboard() {
  return (
    <Layout activePage="Dashboard">
      <div
        style={{
          width: "100%",
          height: "calc(100vh - 70px)",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fff",
        }}
      >
        <img
          src={`${BASE_URL}/images/dashbord-img-caret.jpg`}
          alt="Dashboard caret" 
          crossOrigin="anonymous"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
          }}
        />
      </div>
    </Layout>
  );
}
